// Detects whether the app is being loaded on the client-portal domain —
// either the bare domain (portal.multiaccess.in, no org pre-selected; org is
// resolved from the logged-in user's own token after Direct Grant login,
// same as the original /portal path-based flow) or a per-org branded
// subdomain (acme.portal.multiaccess.in, opt-in for clients who want their
// own personalized URL + pre-login branding). Returns null on the main app
// domain and in local dev (localhost), so path-based /portal access there
// keeps working unchanged. Returns '' for the bare portal domain (no slug —
// still portal mode, just without a pre-known org) and the slug string for
// a subdomain.
export function getPortalSlugFromHost(): string | null {
  const baseDomain = import.meta.env.VITE_PORTAL_BASE_DOMAIN ?? 'portal.multiaccess.in'
  const host = window.location.hostname
  if (host === baseDomain) return ''
  const suffix = `.${baseDomain}`
  if (!host.endsWith(suffix)) return null
  return host.slice(0, -suffix.length)
}
